<div class="summary-section">
    <p *ngIf="years == undefined" class="title-4">{{label}}</p>
    <p *ngIf="years > 0" class="title-4">New LTV in {{years}} years</p>
    <p *ngIf="type == 'currency'" class="title-4">{{value | currency:'GBP':'symbol':'1.0-0'}}</p>
    <p *ngIf="type == 'number'" class="title-4">{{value | number:'1.0-1'}}</p>
    <p *ngIf="type == 'percent'" class="title-4">{{value | percent:'1.2'}}</p>
</div>